export const TABLET_WIDTH = 768;
export const MOBILE_LARGE_WIDTH = 425;
export const MIN_LAPTOP_SMALL_WIDTH = 769;
export const MAX_LAPTOP_SMALL_WIDTH = 972;
export const MIN_LAPTOP_MEDIUM_WIDTH = 973;
export const MAX_LAPTOP_MEDIUM_WIDTH = 1658;
export const MOBILE_CALENDAR_DAYS = 3;
export const TABLET_CALENDAR_DAYS = 5;
export const LAPTOP_CALENDAR_DAYS = 7;
export const NEAREST_AVAILABILITY_END_DAYS = 100;

export const I_CANT_SEE_MY_LIST_ID = -1;
export const LONDON_CARE_HOSPITAL_LIST_ID = 26;
export const COUNTRY_WIDE_HOSPITAL_LIST_ID = 27;
export const LOCAL_HOSPITAL_LIST_ID = 28;
export const CONSULTANT_SELECT_HOSPITAL_LIST_ID = 29;

export const INSURERS_SHORT_NAME_DICTIONARY = {
  [I_CANT_SEE_MY_LIST_ID]: '',
  [LONDON_CARE_HOSPITAL_LIST_ID]: 'LC',
  [COUNTRY_WIDE_HOSPITAL_LIST_ID]: 'CW',
  [LOCAL_HOSPITAL_LIST_ID]: 'L',
  [CONSULTANT_SELECT_HOSPITAL_LIST_ID]: 'CS'
};

export const { GOOGLE_RECAPTCHA_APP_KEY } = process.env



// WEBPACK FOOTER //
// ./components/specialist-page/src/utils/constants.js